import { render, staticRenderFns } from "./CredentialReview.vue?vue&type=template&id=3fccadc0&scoped=true"
import script from "./CredentialReview.vue?vue&type=script&lang=js"
export * from "./CredentialReview.vue?vue&type=script&lang=js"
import style0 from "./CredentialReview.vue?vue&type=style&index=0&id=3fccadc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fccadc0",
  null
  
)

export default component.exports